import { alpha, styled } from '@mui/material/styles';
import { MaterialDesignContent } from 'notistack';

// ----------------------------------------------------------------------

export const StyledNotistack = styled(MaterialDesignContent)(({ theme }) => {
  const lightMode = theme.palette.mode === 'light';

  return {
    '& #notistack-snackbar': {
      ...theme.typography.subtitle2,
      padding: 0,
      fontWeight: '400',
      flexGrow: 1,
    },
    '&.notistack-MuiContent': {
      color: theme.palette.text.primary,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(0.5, 2, 0.5, 1.5),
      backgroundColor: theme.palette.background.paper,
      boxShadow: '1px 5px 8px #0000003d',
      flexWrap: 'nowrap',
      minWidth: '50vw'
    },
    '&.notistack-MuiContent-default': {
      padding: theme.spacing(1, 2, 1, 1),
      color: lightMode ? theme.palette.common.white : theme.palette.grey[800],
      backgroundColor: lightMode ? theme.palette.grey[800] : theme.palette.common.white,
    },
    '&.notistack-MuiContent-info': {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.feedback.info,
    },
    '&.notistack-MuiContent-success': {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.feedback.success,
    },
    '&.notistack-MuiContent-warning': {
      color: theme.palette.greyScale[500],
      backgroundColor: theme.palette.feedback.warning,
    },
    '&.notistack-MuiContent-error': {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.feedback.danger,
    },
    '.go703367398': {
      color: 'inherit'
    },
  };
});

// ----------------------------------------------------------------------

type StyledIconProps = {
  color: 'info' | 'success' | 'warning' | 'error';
};

export const StyledIcon = styled('span')<StyledIconProps>(({ color, theme }) => ({
  width: 44,
  height: 44,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: theme.spacing(1.5),
  color: theme.palette[color].main,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette[color].main, 0.16),
}));
